import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Card, CardActions, CardContent, CircularProgress, Divider, Typography } from '@material-ui/core';
import { Launch } from '@material-ui/icons';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: 'flow-root',
    background: 'none',
  },
  card: {
    overflow: 'visible',
    marginTop: theme.spacing(2),
  },
  cardContent: {
    position: 'relative',
    paddingBottom: 0,
  },
  cardActions: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  divider: {
    marginTop: theme.spacing(2),
  },
  iconBox: {
    position: 'absolute',
    width: theme.spacing(6),
    height: theme.spacing(6),
    padding: theme.spacing(2),
    marginTop: -theme.spacing(4),
    display: 'flex',
    color: 'white',
    transition: theme.transitions.create(['width'], {
      easing: theme.transitions.easing.easeInOut,
      duration: theme.transitions.duration.standard,
    }),
  },
  icon: {
    lineHeight: theme.spacing(6),
    fontSize: theme.spacing(4),
    margin: 'auto',
    color: 'white',
  },
  iconLoading: {
    width: `calc(100% - ${theme.spacing(8)}px)`,
  },
  title: {
    textAlign: 'right',
    color: theme.palette.text.secondary,
    fontSize: theme.spacing(1.75),
    maxWidth: 'calc(100% - 80px)',
    marginRight: 0,
    marginLeft: 'auto',
  },
  value: {
    textAlign: 'right',
    color: theme.palette.text.primary,
    fontSize: theme.spacing(2.25),
  },
  actionTextButton: {
    textTransform: 'none',
    color: theme.palette.text.secondary,
    paddingLeft: theme.spacing(1),
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    justifyContent: 'start',
  },
  actionIcon: {
    fontSize: '1.5em',
    margin: 'auto',
    marginRight: 0,
  },
}));

export interface ITile {
  title?: string;
  value?: any;
  Icon?: any;
  color?: string;
  children?: any;
  actionText?: string;
  ActionIcon?: any;
  actionOnClick?: any;
  hide?: boolean;
  loading?: boolean;
}

export default function Tile({ title, value, Icon, color, children, actionText, ActionIcon, actionOnClick, hide = false, loading = false }: ITile) {
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <Card style={{ display: hide ? 'none' : '' }} className={classes.card} raised>
        <CardContent className={classes.cardContent}>
          {Icon ? (
            <Card className={clsx(classes.iconBox, loading ? classes.iconLoading : '')} style={{ backgroundColor: color }} raised>
              {loading ? <CircularProgress className={classes.icon} /> : <Icon className={classes.icon} />}
            </Card>
          ) : null}
          <Typography className={classes.title} gutterBottom>
            {title ?? '\xa0'}
          </Typography>
          <Typography className={classes.value} gutterBottom>
            {value ?? '\xa0'}
          </Typography>
          {children}
          {actionText ? <Divider className={classes.divider} /> : null}
        </CardContent>
        <CardActions className={classes.cardActions}>
          {actionText || ActionIcon ? (
            actionOnClick ? (
              <Button style={{ width: ActionIcon ? '100%' : '' }} className={classes.actionTextButton} onClick={actionOnClick} size='small'>
                {actionText}
                {ActionIcon ? ActionIcon === true ? <Launch className={classes.actionIcon} /> : <ActionIcon className={classes.actionIcon} /> : null}
              </Button>
            ) : (
              <Typography>{actionText}</Typography>
            )
          ) : null}
        </CardActions>
      </Card>
    </div>
  );
}
